'use strict';
import util from './util';
import header from './header';
import currentLayout from './detect-layout';
import analytics from './analytics';

var currentQuery = null,
	lastQuery = null,
	runningQuery = null,
	listTotal = -1,
	listCurrent = -1,
	delay = 30,
	$resultsContainer = $('.query-search-overlay'),
	$popularResultsContainer = $('.popular-search-overlay'),
	searchSuggestioncallTimeout = null;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
	switch (keyCode) {
		case 38:
			// keyUp
			listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
			break;
		case 40:
			// keyDown
			listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
			break;
		default:
			// reset
			listCurrent = -1;
			return false;
	}

	$resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
	$('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
	return true;
}

var searchsuggest = {
	/**
	 * @function
	 * @description Configures parameters and required object instances
	 */
	init: function (container, defaultValue) {
		var $searchContainer = $(container);
		var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
		var $searchField = $searchForm.find('input[name="q"]');
		var $submitButton = $searchForm.find('button[type="submit"]');
		var $cancelButton = $searchForm.find('button[type="reset"]');
		var $closeButton = $('.header-search-wrapper').find('.close-wrapper');

		// disable browser auto complete
		$searchField.attr('autocomplete', 'off');

		// Search overlay show/hide
		$('.search-icon, .header-search .icon-close, .js-search-link').on('click touchend', function (e) {
			e.preventDefault();
			var currLayoutVal = currentLayout.init();
			$('html').toggleClass('sticky-header-search');

			if($(e.target).hasClass('icon-close')) {
				runningQuery = null;
				searchsuggest.popularSearch(runningQuery);
				$('#q').css('font-weight', 'normal');
				$('#search-suggestions').removeClass('query-search, popular-search');
			} else {
				if($.trim($popularResultsContainer.html()) == '') {
					searchsuggest.popularSearch(runningQuery);
				}
				$('#search-suggestions').removeClass('query-search').addClass('popular-search');
				
				analytics.populateSearchSuggestion();
			}

			if (currLayoutVal == 'desktop') {
				if (util.isMobile()) {
					$('.utility-nav > ul > li').removeClass('hovered');
				}
			}

			if (!$('html').hasClass('sticky-header-search')) {
				if(!$searchField.val().trim().length) {
					$searchField.val('');
				} else {
					$closeButton.addClass('clicked');
					($cancelButton.css('display') != 'none') ? $cancelButton.trigger('click') : $closeButton.trigger('click');
					$closeButton.removeClass('clicked');
				}
				$searchField.blur();
				$submitButton.prop('disabled', true);
				lastQuery = null;
			} else {
				$searchField.trigger("focus");
			}
			
			$('.nav-open').removeClass('nav-open');

			if ($searchField.val() === defaultValue) {
				$searchField.val('');
			}
			header.handleResizeForBannerMessages();
			return false;
		});

		// cancel button hide
		$cancelButton.on('click', function (e) {
			e.stopPropagation();
			this.clearResults();
			lastQuery = null;
			$cancelButton.hide();
			$submitButton.prop('disabled', true);
			$searchField.trigger("focus");
			runningQuery = null;
			this.popularSearch(runningQuery);
			$('#q').css('font-weight', 'normal');
			$('#q').css('text-shadow', 'none');
			$('#search-suggestions').removeClass('query-search').addClass('popular-search');
		}.bind(this));

		function closeOverlay() {
			if(!$searchField.val().trim().length) {
				$searchField.val('');
				$closeButton.trigger('click');
			} else {
				$closeButton.addClass('clicked');
				$cancelButton.trigger('click');
				$closeButton.removeClass('clicked');
			}
			lastQuery = null;
			$('html').removeClass('sticky-header-search');

			$searchField.blur();
		}
				
		// Close search overlay
		$(document).on('click touchstart', '.overlay', function () {
			if ($('html').hasClass('sticky-header-search')) {
				closeOverlay();
			}
		});

		$(document).on('keyup', function (e) {
			if (e.keyCode == 27 && $('html').hasClass('sticky-header-search')) { // escape key maps to keycode `27`
				closeOverlay();
				$('.search-link.no-touch').children('a').focus();
				header.handleResizeForBannerMessages();
			}
		}.bind(this));

		// on blur listener
		$searchField.on('blur', function (e) {
			this.checkInput(e, $searchField, $submitButton, defaultValue);
			$('#q-hint').val('');
		}.bind(this));

		// Populate popular text in header search 
		$(document).on('click', '.header-search .popular-search li a', function (e) {
			e.preventDefault();
			popularSearch($(this).text());
		});

		var popularSearch = function (query) {
			lastQuery = null
			$searchField.val(query)
			currentQuery = query;
			$cancelButton.show();
			// no query currently running, init an update
			if ((!runningQuery && currentQuery.length > 2) || (!runningQuery && currentQuery.length == 0)) {
				runningQuery = currentQuery;
				setTimeout(this.suggest.bind(this), delay);
			}
		}.bind(this);

		$searchField.on('input', function() {
			if($(this).val() != $('#q-hint').val()) {
				$('#q').css('font-weight', 'normal');
				$('#q-hint').val('');
			}
		});
		// on key up listener
		$searchField.on('keyup', function (e) {
			// get display cancel button on type
			if ($searchField.val().trim().length > 0) {
				$cancelButton.show();
			} else {
				// Hide hint text.
				$('#q-hint').val('');
				$('#q').css('font-weight', 'normal');
				$cancelButton.hide();
				$('#search-suggestions').removeClass('query-search').addClass('popular-search');
			}

			// get keyCode (window.event is for IE)
			var keyCode = e.keyCode || window.event.keyCode;

			// check and treat up and down arrows
			if (handleArrowKeys(keyCode)) {
				return;
			}
			// check for an ENTER or ESC
			if (keyCode === 13 || keyCode === 27) {
				this.clearResults();
				this.checkInput(e, $searchField, $submitButton, defaultValue);
				$('#q-hint').val('');
				return;
			}

			currentQuery = $searchField.val().trim();

			// no query currently running, init an update
			if ((!runningQuery && currentQuery.length > 2) || (!runningQuery && currentQuery.length == 0)) {
				runningQuery = currentQuery;
				clearTimeout(searchSuggestioncallTimeout);
				searchSuggestioncallTimeout = setTimeout(this.suggest.bind(this), 800);
			} else {
				
			}
		}.bind(this));

		$submitButton.on('click', function (e) {
			e.preventDefault();
			$searchForm.find('input[name="q"]').val($searchField.val().trim());
			this.checkInput(e, $searchField, $submitButton, defaultValue);
			$searchForm.submit();
		}.bind(this));

		// home page only - searchbox's events
		$('.home-page form[name="simpleSearch"] input[name="q"]').on('focusin', function (e) {			
			runningQuery = null;
			this.popularSearch(runningQuery);
			$('#search-suggestions').removeClass('query-search').addClass('popular-search');
		}.bind(this));	
		// home page only - close search suggestion on outside click event 
		function closeSuggestionOutsideClick() {
			var $homePage = $('.home-page'),
				$container = $(".search-wrapper .search-inner"),
				$suggestions = $container.find("#search-suggestions");
				if($homePage.length && $container.length) {
					$(document).on('mouseup', function(e) {								
						if (($suggestions.hasClass('popular-search') || $suggestions.hasClass('query-search')) && (!$container.is(e.target) && $container.has(e.target).length === 0)) {
							$suggestions.removeClass('popular-search');
							$suggestions.removeClass('query-search');
						}
					});
				}
		}
		closeSuggestionOutsideClick();
	},

	/**
	 * @function
	 * @description trigger suggest action
	 */
	suggest: function () {
		// check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
		// (we had a little delay)
		if (runningQuery !== currentQuery) {
			// update running query to the most recent search phrase
			runningQuery = currentQuery;
		}

		// if it's empty clear the results box and return
		if (runningQuery.length === 0) {
			this.clearResults();
			runningQuery = null;
			this.popularSearch(runningQuery);
			return;
		}

		// build the request url
		var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

		// execute server call
		$.get(reqUrl, function (data) {
			var suggestionHTML = data,
				ansLength = $(suggestionHTML).filter('.search-suggestion-wrapper').length;

			// if there are results populate the results div
			if (ansLength === 0) {
				this.clearResults();
				this.popularSearch(runningQuery);
				$('#search-suggestions').removeClass('query-search').addClass('popular-search');
			} else {
				// update the results div
				var searchKeyword = $('#q').val();
				var searchSuggestionKeywordMatchRegex = RegExp(searchKeyword, 'gi');
				$('#search-suggestions').removeClass('popular-search').addClass('query-search');
				$resultsContainer.html(suggestionHTML);
				$resultsContainer.find('.category-name, .product-name, .content-name').html(function() {
					return $(this).text().replace(searchSuggestionKeywordMatchRegex,'<strong>' + searchKeyword + '</strong>')
				});
			}

			// Show hint text.
			var $hintTextInput = $('#q-hint'),
				$searchInput = $('#q');
			if (suggestionHTML.indexOf('hint-text') === -1) {
				$hintTextInput.val('');
				$searchInput.css('font-weight', 'normal');
			} else {
				$searchInput.val($searchInput.val().replace(/  +/g, ' '));
				$hintTextInput.val($searchInput.val() + $('.hint-phrase .hint-text').text());
				$searchInput.css('text-shadow', '1px 0 0 #000');
			}

			// record the query that has been executed
			lastQuery = runningQuery;
			// reset currently running query
			runningQuery = null;

			// check for another required update (if current search phrase is different from just executed call)
			if (currentQuery !== lastQuery) {
				// ... and execute immediately if search has changed while this server call was in transit
				runningQuery = currentQuery;
				setTimeout(this.suggest.bind(this), delay);
			}
			this.hideLeftPanel();
			
			analytics.populateSearchSuggestion();
			
		}.bind(this));
	},
	/**
	 * @function
	 * @description
	 */
	clearResults: function () {
		if (!$resultsContainer) {
			return;
		}
		$resultsContainer.empty();
	},
	/**
	 * @function
	 * @description
	 */
	hideLeftPanel: function () {
		//hide left panel if there is only a matching suggested custom phrase
		if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
			$('.search-suggestion-left-panel').css('display', 'none');
			$('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
			$('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
		}
	},
	checkInput: function (e, $searchField, $submitButton, defaultValue) {
		if ($searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()) {
			e.stopImmediatePropagation();
			$searchField.val(defaultValue);
			return false;
		}
	},
	/**
	 * @function
	 * @description: execute server call for popular search
	 */
	popularSearch: function(query) {
		var popularSearchUrl = util.appendParamsToUrl(Urls.getPopularSearchSuggest, {'q': query, 'format': 'ajax'});
		$.get(popularSearchUrl, function (data) {
			$popularResultsContainer.html(data);
		});
	}
};

export default searchsuggest;